// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"dp-9SIhICep","content":"dp-B6b5kmmq","gradientBackground":"dp-7DfNrvgc","gradient-slide":"dp-vDKa9h2l"};